import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import heTranslations from './locales/he.json';
import arTranslations from './locales/ar.json';
import frTranslations from './locales/fr.json';

const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem('medilis_ui_language');
    return stored || 'en';
  } catch (error) {
    return 'en';
  }
};

// Radical embed (systemCode=RADICAL) is English-only; CRE gets translations.
const allowsTranslations = () => {
  try {
    // Check URL params first (available immediately, before store initialization)
    const urlParams = new URLSearchParams(window.location.search);
    const systemCode = urlParams.get('systemCode');
    // If systemCode=RADICAL - always use English
    if (systemCode === 'RADICAL') {
      return false;
    }
    // Otherwise (CRE) allow translations
    return true;
  } catch (error) {
    return true; // Default: allow translations
  }
};

i18n
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    supportedLngs: ['en', 'es', 'he', 'ar', 'fr'],
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'protocol', 'zikaron', 'medclip', 'acr'],
    resources: {
      en: {
        common: enTranslations?.common ?? enTranslations,
        protocol: enTranslations?.protocol ?? {},
        zikaron: enTranslations?.zikaron ?? {},
        medclip: enTranslations?.medclip ?? enTranslations?.zikaron ?? {},
        acr: enTranslations?.acr ?? {},
      },
      es: {
        common: esTranslations?.common ?? esTranslations,
        protocol: esTranslations?.protocol ?? {},
        zikaron: esTranslations?.zikaron ?? {},
        medclip: esTranslations?.medclip ?? enTranslations?.medclip ?? {},
        acr: esTranslations?.acr ?? {},
      },
      he: {
        common: heTranslations?.common ?? heTranslations,
        protocol: heTranslations?.protocol ?? {},
        zikaron: heTranslations?.zikaron ?? {},
        medclip: heTranslations?.medclip ?? enTranslations?.medclip ?? {},
        acr: heTranslations?.acr ?? {},
      },
      ar: {
        common: arTranslations?.common ?? arTranslations,
        protocol: arTranslations?.protocol ?? {},
        zikaron: arTranslations?.zikaron ?? {},
        medclip: arTranslations?.medclip ?? enTranslations?.medclip ?? {},
        acr: arTranslations?.acr ?? {},
      },
      fr: {
        common: frTranslations?.common ?? frTranslations,
        protocol: frTranslations?.protocol ?? {},
        zikaron: frTranslations?.zikaron ?? {},
        medclip: frTranslations?.medclip ?? enTranslations?.medclip ?? {},
        acr: frTranslations?.acr ?? {},
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    debug: false,
  });

if (typeof window !== 'undefined') {
  // Override the getResource function to always return English for Radical users
  const originalGetResource = i18n.getResource.bind(i18n);
  i18n.getResource = (lng, ns, key, options) => {
    // For Radical users, always use English resources
    if (!allowsTranslations() && lng !== 'en') {
      return originalGetResource('en', ns, key, options);
    }
    return originalGetResource(lng, ns, key, options);
  };

  // Override the t function to always use English for Radical users
  const originalT = i18n.t.bind(i18n);
  i18n.t = (key, options) => {
    // For Radical users, always use English
    if (!allowsTranslations() && i18n.language !== 'en') {
      return originalT(key, { ...options, lng: 'en' });
    }
    return originalT(key, options);
  };

  i18n.on('languageChanged', (lng) => {
    try {
      localStorage.setItem('medilis_ui_language', lng);
    } catch (error) {
      // Silent fail
    }
  });
}

export default i18n;
